var _g, _mask, _rect, _rect2, _rect3, _rect4, _rect5, _mask2, _rect6, _rect7, _rect8, _rect9, _rect0, _mask3, _rect1, _rect10, _rect11, _rect12, _rect13, _mask4, _rect14, _rect15, _rect16, _rect17, _rect18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_27_31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_27_31)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_27_31)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_27_31)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_27_31)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_27_31)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_27_31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_27_31)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_27_31)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_27_31)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_27_31)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_27_31)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_27_31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_27_31)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_27_31)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_27_31)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_27_31)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_27_31)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_27_31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_27_31)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_27_31)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_27_31)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_27_31)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_27_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_31",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_31",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.c81ba0b27a1871cc48cbc235a95975f4.svg";
export { ForwardRef as ReactComponent };